module.exports = __webpack_public_path__ + "static/media/iconRadioButtonCheck.b6df3e97.svg";